import { apiPaths, customerApiBase } from "enum/paths.enum";
import { ILabelJob } from "models/labelJob/labelJob.model";
import { ISalesAccount } from "models/salesAccount/salesAccount.model";
import { IFetchPostResponse } from "services/api";
import { fetchAll, fetchSingle } from "services/get";
import { post } from "services/post";
import { S19LabelResponse } from "interfaces/api.interface";
import { CreateLabelJobRequestDto } from "./dtos/create-label-job.request.dto";
import { FetchLabelJobResponseDto } from "./dtos/fetch-label-job.response.dto";
import { FetchLabelJobsQuery } from "./dtos/fetch-label-jobs.query.dto";
import {
  FetchLabelJobsResponseDto,
  FetchLabelJobsHistoryResponseDto,
} from "./dtos/fetch-label-jobs.response.dto";
import { IShipment } from "models/shipment/shipment.model";

export const createLabelJob = async (
  salesAccountUUID: ISalesAccount["uuid"],
  values: CreateLabelJobRequestDto
): Promise<IFetchPostResponse<ILabelJob>> => {
  return await post(
    customerApiBase + "/" + salesAccountUUID + apiPaths.labelJobs,
    values
  );
};

export const markLabelJobAsDownloaded = async (
  salesAccountUUID: ISalesAccount["uuid"],
  labelJobUUID: ILabelJob["uuid"]
): Promise<IFetchPostResponse<ILabelJob>> => {
  return await post(
    customerApiBase +
      "/" +
      salesAccountUUID +
      apiPaths.labelJobs +
      "/" +
      labelJobUUID +
      "/set-downloaded"
  );
};

// Records that a person has just seen these shipments' labels by a route that
// isn't a whole label job (those use markLabelJobAsDownloaded).
export const recordLabelsDownloaded = async (
  salesAccountUUID: ISalesAccount["uuid"],
  shipmentIds: IShipment["id"][]
): Promise<IFetchPostResponse<{ success: boolean }>> => {
  return await post(
    customerApiBase +
      "/" +
      salesAccountUUID +
      apiPaths.shipments +
      "/label-downloaded",
    { shipmentIds: shipmentIds.map(String) }
  );
};

export const fetchLabelJobsHistory = async (
  salesAccountUUID: ISalesAccount["uuid"],
  query?: FetchLabelJobsQuery
): Promise<FetchLabelJobsHistoryResponseDto> => {
  return await fetchAll(
    customerApiBase + "/" + salesAccountUUID + apiPaths.labelJobs + "/history",
    query
  );
};

export const fetchLabelJobs = async (
  salesAccountUUID: ISalesAccount["uuid"],
  query?: FetchLabelJobsQuery
): Promise<FetchLabelJobsResponseDto> => {
  return await fetchAll(
    customerApiBase + "/" + salesAccountUUID + apiPaths.labelJobs,
    query
  );
};

export const fetchLabelJob = async (
  salesAccountUUID: ISalesAccount["uuid"],
  uuid: ILabelJob["uuid"]
): Promise<FetchLabelJobResponseDto> => {
  return await fetchSingle(
    customerApiBase + "/" + salesAccountUUID + apiPaths.labelJobs + "/" + uuid
  );
};

export const createS19Labels = async (
  salesAccountUUID: ISalesAccount["uuid"],
  shipmentIds: IShipment["id"][]
): Promise<IFetchPostResponse<S19LabelResponse>> => {
  return await post(
    customerApiBase + "/" + salesAccountUUID + apiPaths.labelJobs + "/s19",
    shipmentIds
  );
};
